import { render, staticRenderFns } from "./Suzuki.vue?vue&type=template&id=69df2c6c&"
import script from "./Suzuki.vue?vue&type=script&lang=js&"
export * from "./Suzuki.vue?vue&type=script&lang=js&"
import style0 from "./Suzuki.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports